import * as React from 'react';
import { Loader } from '../Loader';
import { injectIntl, useIntl } from 'react-intl';
import { TranslateText } from '../TranslateText';

// Typescript defination
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
;

// Icon Widget component with props and its types
const _IconWidget = props => {
  const {
    loader,
    image,
    imageAlt,
    imageTooltip,
    title,
    text,
    width,
    imageSize,
    disabled
  } = props;
  const intl = useIntl();
  const mapImageSize = {
    "small": "kc-ui-sm-image",
    "medium": "kc-ui-md-image",
    "large": "kc-ui-xl-image"
  };
  return /*#__PURE__*/_jsx(React.Fragment, {
    children: /*#__PURE__*/_jsx("div", {
      className: `kc-ui-colm kc-ui-icon ${disabled && "kc-ui-disabled "}  ${loader && "kc-ui-loader-overlay"}`,
      style: {
        width: `${width}`
      },
      children: /*#__PURE__*/_jsxs("div", {
        className: `kc-ui-colm-div ${text && 'kc-ui-icon-align'}`,
        children: [title ? /*#__PURE__*/_jsx("h4", {
          children: /*#__PURE__*/_jsx(TranslateText, {
            id: title
          })
        }) : null, loader ? /*#__PURE__*/_jsx(Loader, {
          loader: loader
        }) : /*#__PURE__*/_jsxs(React.Fragment, {
          children: [/*#__PURE__*/_jsx("div", {
            className: "kc-ui-icon-image",
            children: /*#__PURE__*/_jsx("img", {
              src: image,
              alt: imageAlt ? intl.formatMessage({
                id: imageAlt
              }) : '',
              title: imageTooltip ? intl.formatMessage({
                id: imageTooltip
              }) : '',
              className: mapImageSize[imageSize]
            })
          }), text && /*#__PURE__*/_jsx("div", {
            className: "kc-ui-status-icon",
            children: /*#__PURE__*/_jsx("div", {
              className: "kc-ui-status-text",
              children: /*#__PURE__*/_jsx(TranslateText, {
                id: text
              })
            })
          })]
        })]
      })
    })
  });
};
// Prop type defination for compile ime

// Default props
_IconWidget.defaultProps = {
  loader: false,
  image: "",
  imageAlt: "",
  imageTooltip: "",
  text: "",
  imageSize: "small",
  width: '100%',
  title: "",
  disabled: false
};
export const IconWidget = injectIntl( /*#__PURE__*/React.memo(_IconWidget));